import Estado from "../EstadoDialogoCliente";
import _ from "lodash";
import ActionTypeCliente from "./ActionTypeCliente";
import { ModosOp } from "../../../isp._comun/iu/_principal/constantesIuPrin";
import Contacto from "../Contacto";
export default class ActionContactoClienteSet extends ActionTypeCliente {
    constructor(pathAtributo, valorASetear) {
        super(valorASetear);
        this.pathAtributo = pathAtributo;
    }

    /* ejecutar(estado, nuevoEstado) {
        const estado_Cargado_EstaVacio =
            Object.keys(estado.domain.cargado).length === 0 ? true : false;
        if (estado_Cargado_EstaVacio) {
            this.darleUnNuevoValorALaPropiedadDelaNuevaEntidad(estado, nuevoEstado);
            return nuevoEstado;
        }
    } */

    ejecutar(estado, nuevoEstado) {
        // nuevoEstado.flag.sensorCambioNombreContacto=!estado.flag.sensorCambioNombreContacto;

        const estado_Cargado_EstaVacio =
            Object.keys(estado.domain.cargado).length < 1 ? true : false;
        if (estado_Cargado_EstaVacio) {
            this.darleUnNuevoValorALaPropiedadDelaNuevaEntidad(estado, nuevoEstado);
            return nuevoEstado;
        }

        // let valorPorSetear=_.get(nuevoEstado.domain, pathAtributo);
        let valorDePropPorSetear = this.payload;
        let valorDePropCargada = _.get(estado.domain.cargado, this.pathAtributo, null);

        const sonValoresIguales = valorDePropPorSetear === valorDePropCargada;
        // const existeAtributoEnEstadoParaUpdate = _.has(nuevoEstado.paraUpdate, pathAtributo);

        if (sonValoresIguales) {
            if (_.has(estado.domain.update, this.pathAtributo)) {
                this.hacerALaPropiedadIgualASuVersionCargadaCuandoNoloEraAntes(estado, nuevoEstado);
                if (nuevoEstado.domain.nroUpdates === 0) {
                    nuevoEstado.flag.modoOperacion = ModosOp.OK;
                }
                return nuevoEstado;
            }
            return nuevoEstado;
        }

        //sonValoresDiferentes y la prop existe en el estado Update
        if (_.has(estado.domain.update, this.pathAtributo)) {
            if (valorDePropPorSetear === _.get(estado.domain.update, this.pathAtributo)) {
                return nuevoEstado;
            }
            this.hacerALaPropiedadDiferenteDeSuVersionCargadaPorEnesimaVez(estado, nuevoEstado);
            return nuevoEstado;
        }

        //sonValoresDiferentes y la prop NO existe en el estado Update
        this.hacerALaPropiedadDiferenteDeSuVersionCargadaPorPrimeraVez(estado, nuevoEstado);
        if (nuevoEstado.domain.nroUpdates >= 1) {
            nuevoEstado.flag.modoOperacion = ModosOp.MODIFICAR;
        }
        return nuevoEstado;
    }

    /**@abstract */
    darleUnNuevoValorALaPropiedadDelaNuevaEntidad(estado, nuevoEstado) {
        // let val=Contacto.labelDefinirNuevoContacto;
        // new Contacto();
        const ultimoIndice = estado.domain.screen.contactos.listaNombres.length-1;
        if (estado.domain.screen.contactos.indexSeleccionado === ultimoIndice) {
            // _.set(nuevoEstado.domain.screen.contactos.valorListaNombres, this.pathAtributo, this.payload);
            // _.set(nuevoEstado.domain.screen.contactos.atributos, this.pathAtributo, this.payload);
            _.set(
                nuevoEstado.domain.screen.contactos.contactoPorDefinir,
                this.pathAtributo,
                this.payload,
            );
            // let cantidadDeNombres = estado.domain.screen.contactos.listaNombres.length;
            // nuevoEstado.domain.screen.contactos.listaNombres.splice(cantidadDeNombres-1,0,{nombre:this.payload})
            // let nuevoContacto = new Contacto();
            // _.set(nuevoContacto, this.pathAtributo, this.payload);
            // nuevoEstado.domain.screen.contactos.data.push(nuevoContacto);
            // nuevoEstado.domain.screen.contactos.indexData=0;
            // let atributo = _.words(this.pathAtributo,/[^\\.]+/g).pop();
            // _.set(nuevoEstado.domain.screen.personasContacto.atributos, this.pathAtributo, this.payload);
        } else {
            _.set(
                nuevoEstado.domain.screen.contactos.data[
                    estado.domain.screen.contactos.indexSeleccionado
                ],
                this.pathAtributo,
                this.payload,
            );
            // let contactoExistente = estado.domain.screen.contactos.data.find((element) => element > 10);
            // let contactoExistente = estado.domain.screen.contactos.data[estado.domain.screen.contactos.indexData];
            // _.set(contactoExistente, this.pathAtributo, this.payload);
        }
        _.set(nuevoEstado.domain.screen.contactos.atributos, this.pathAtributo, this.payload);
        // _.set(nuevoEstado.domain.screen.contactos.valorListaNombres, this.pathAtributo, this.payload);
        // _.set(nuevoEstado.domain.screen.personasContacto.atributos, this.pathAtributo, this.payload);
    }

    /**@abstract */
    hacerALaPropiedadIgualASuVersionCargadaCuandoNoloEraAntes(estado, nuevoEstado) {
        const valorPropCargada = _.get(estado.domain.cargado, this.pathAtributo);
        _.set(nuevoEstado.domain.screen, this.pathAtributo, valorPropCargada);
        _.unset(nuevoEstado.domain.update, this.pathAtributo);
        nuevoEstado.domain.nroUpdates--;
    }

    /**@abstract */
    hacerALaPropiedadDiferenteDeSuVersionCargadaPorPrimeraVez(estado, nuevoEstado) {
        // nuevoEstado.domain.screen.tipoDoc = estado.domain.cargado.tipoDoc;
        _.set(nuevoEstado.domain.screen, this.pathAtributo, this.payload);

        if (this.payload !== null) {
            _.set(nuevoEstado.domain.update, this.pathAtributo, this.payload);
            nuevoEstado.domain.nroUpdates++;
        }
    }

    /**@abstract */
    hacerALaPropiedadDiferenteDeSuVersionCargadaPorEnesimaVez(estado, nuevoEstado) {
        _.set(nuevoEstado.domain.screen, this.pathAtributo, this.payload);

        if (this.payload !== null) {
            _.set(nuevoEstado.domain.update, this.pathAtributo, this.payload);
            return;
        }
        _.unset(nuevoEstado.domain.update, this.pathAtributo, this.payload);
        nuevoEstado.domain.nroUpdates--;
    }

    continuarCambiosEnEstado(nuevoEstado, atributo, indice) {
        // continuarCambiosEnEstado(nuevoEstado) {

        if (nuevoEstado.flag.modoOperacion === ModosOp.GUARDAR) {
            return nuevoEstado;
        }

        //Consecuencias
        let esIgualAlRegistrado =
            nuevoEstado.campo.editable.codigoCliente === Estado.Registrado.codigoCliente;

        if (esIgualAlRegistrado) {
            nuevoEstado.update.codigoCliente = false;
            nuevoEstado.nroUpdates--;
            delete Estado.ParaUpdate.codigoCliente;
        } else {
            nuevoEstado.update.codigoCliente = true;
            nuevoEstado.nroUpdates++;
            // console.log(Estado.ParaUpdate);
            Estado.ParaUpdate.codigoCliente = nuevoEstado.campo.editable.codigoCliente;
        }
        return this.actualizarBotonAccion(nuevoEstado);
        // return this.actualizarBotonAccion(nuevoEstado, esIgualAlRegistrado);
    }
}
